import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import {
  TooFarAwayContent,
  type TooFarAwayContentProps,
} from "../../Timekeeping/TimekeepingActions/TooFarAwayContent";

type TooFarAwayBottomSheetProps = Omit<TooFarAwayContentProps, "workplaceName"> & {
  modalState: UseModalState;
  workplaceName: string;
};

export function TooFarAwayBottomSheet({
  modalState,
  workplaceName,
  action,
  shiftId,
  workerId,
  workplaceId,
  detectionMethod,
  currentInside,
  lastGeofenceChangeAt,
  onTryAgain,
  onSkipLocationCheck,
  onCancel,
}: TooFarAwayBottomSheetProps) {
  return (
    <BottomSheet modalState={modalState} canDismiss={false}>
      <TooFarAwayContent
        workplaceName={workplaceName}
        action={action}
        shiftId={shiftId}
        workerId={workerId}
        workplaceId={workplaceId}
        detectionMethod={detectionMethod}
        currentInside={currentInside}
        lastGeofenceChangeAt={lastGeofenceChangeAt}
        onTryAgain={onTryAgain}
        onSkipLocationCheck={onSkipLocationCheck}
        onCancel={onCancel}
      />
    </BottomSheet>
  );
}
